import { Component, OnInit, Inject } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormBuilder } from '@angular/forms';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-movetoFileManager',
  templateUrl: './movetoFileManager.component.html',
  styleUrls: ['./movetoFileManager.component.scss'] 
})

export class MovetoFileManagerComponent implements OnInit {
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  MyDrivefoldersList:any;
  activeNodeFileManager:string="";
  menuHeaderMyDrive: any = [];
  FileManagerFolderListLeft:any;
  selectButtonMyDriveShow:boolean=false;
  foldersMyDriveListShow:boolean=false;
  hierarchyList: any;
  fileManagerID:string="";
  OfficeIDList: any=[];
  myOfficeID: any;
  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID:node.fileManagerItemID,
      parentID:node.parentID,
      level: level,
      isShared:node.isShared
    };
  }
  
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  parentIdTomove:number;
  fileManagerItemTobeMoved:number;
  parentIdTobeMoved:number;
  newParentFolderSelected: any;
  spinner:boolean=false;

  constructor( private _dataSharingService: DataSharingService,private dialog: MatDialog,
    public dialogRef: MatDialogRef<MovetoFileManagerComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private settingsService: SettingService,
    private statusConst: StatusConstant,private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });	 
  
    this.parentIdTomove = 0;
    this.fileManagerItemTobeMoved = data.fileManagerItemID;
    this.parentIdTobeMoved = data.parentId;
  }  
  
  ngOnInit(): void {  
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }
  
  // ===== My Drive ======//

  breadCrumbMyDriveMainClick(){
    this.MyDrivefoldersList=[];
    this.FileManagerFolderListLeft=[];
    this.menuHeaderMyDrive=[];
    this.activeNodeFileManager="";
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList(); 
    this.selectButtonMyDriveShow=false;
    this.foldersMyDriveListShow=false; 
  }

  breadCrumbMyDrive(menu,index){
    this.selectButtonMyDriveShow=false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow=false;
    var data = this.menuHeaderMyDrive[index];
    this.getFileManagerFoldersList(data.id);
  }

  radioChangeMyDrive(form){
    this.fileManagerID=form.fileManagerItemID;
    this.selectButtonMyDriveShow=true; 
    if(form.isFile==false){
      this.showChildFolders(form);
      return;
    }
    if(form.isFile==true){
      this.MyDrivefoldersList.forEach(e => {      
        e.isChecked=false
     });
     this.MyDrivefoldersList.forEach(e => {
      if(e.fileManagerItemID==form.fileManagerItemID) {
        e.isChecked=true
      }
     });
    }          
  }

  

  onFolderSelectToMove(){
    let ReqModel = {
      fileManagerItemIDs:this.fileManagerItemTobeMoved,
      newParentID:this.parentIdTomove,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId)
    }
    this.spinner=true;
    this.selectButtonMyDriveShow=false;
    this.settingsService.MoveFileManagerItems(ReqModel).subscribe((response)=>{
       if(response.data== true){
           this.toastr.success("Record moved successfully in selected folder.", '', {
           timeOut: 3000,
        });
        this._dataSharingService.sendSelectedParentFolderIDForMove(this.newParentFolderSelected);
        this.dialogRef.close(this.menuHeaderMyDrive);
      }else{
        this.spinner=false;
       this.selectButtonMyDriveShow=false;
      }
    })
  }

  getFileManagerFoldersList(folderId){
    let ReqModel = {
      fileManagerItemID:folderId,
      name:"",
      pageIndex:0,
      pageSize:0,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList:this.OfficeIDList
    }    
    this.settingsService.FileManagerItemsWithHierarchy(ReqModel).subscribe(response=>{
      if(response.status == this.statusConst.statusSuccess){
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if( this.hierarchyList == null || this.hierarchyList == null){
            this.menuHeaderMyDrive=[];                       
         } else{
               this.menuHeaderMyDrive=[];
               this.hierarchyList.forEach(e => {
               this.menuHeaderMyDrive.push({ label: e.name,id:e.fileManagerItemID,icon: 'navigate_next' });
                });            
            }
            if(this.MyDrivefoldersList!=null){
              this.MyDrivefoldersList.forEach(e => {      
                e.isChecked=false
             });
            }       

        if(this.MyDrivefoldersList==null || this.MyDrivefoldersList.length==0){
          this.MyDrivefoldersList=[];
          this.foldersMyDriveListShow=true;
          this.selectButtonMyDriveShow = true;
          this.parentIdTomove = folderId;
          this.activeNodeFileManager = folderId;
        }else{
          this.foldersMyDriveListShow=false;    
          this.selectButtonMyDriveShow = true;
          this.parentIdTomove = folderId;
          this.activeNodeFileManager = folderId;          
        }
      }
    });
  }
 

  getFileManagerFolderList(){
    let ReqModel = {
      folderID: 0,
      folderName: "", 
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.settingsService.getFoldersListForFML(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          this.dataSourceFileManager.data = this.FileManagerFolderListLeft.filter(m=>m.fileManagerItemID!=this.parentIdTobeMoved);
        }
        else {
        }
      }
      else {
      }
    });  
  }


  showChildFolders(folder){
    this.selectButtonMyDriveShow=false;
    this.newParentFolderSelected = folder;
    this.activeNodeFileManager=folder.fileManagerItemID;   
    this.getFileManagerFoldersList(folder.fileManagerItemID);     
  }
  
  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

  close() {
     // For My Drive // 
     this.menuHeaderMyDrive=[];
     this.MyDrivefoldersList=[];
     this.FileManagerFolderListLeft=[];    
     this.activeNodeFileManager="";
     this.selectButtonMyDriveShow=false;
     this.dialog.closeAll();
  } 
  
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID:number;
  parentID:number;
  isShared:boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID:number;
  parentID:number;
  isShared:boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID:number;
  parentID:number;
  isShared:boolean;
}